var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    class: "ptc-popup-layer ".concat(!_vm.isMask ? 'layer-none' : '', " ").concat(_vm.position),
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShow,
      expression: "isShow"
    }],
    class: "ptc-popup ".concat(_vm.position),
    style: {
      width: _vm.width
    }
  }, [_vm.ishasHeader ? _c('div', [_vm._t("header", function () {
    return [_c('div', {
      staticClass: "popup-title"
    }, [_c('h2', [_vm._v(_vm._s(_vm.confirmTitleText || _vm.titleText))])])];
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [_vm._v("\n      " + _vm._s(_vm.confirmContentText || _vm.contentText) + "\n    ")]), _vm._v(" "), _vm._t("footer", function () {
    return [_c('div', {
      staticClass: "popup-bottom"
    }, [_c('div', {
      staticClass: "btn cancel",
      on: {
        "click": _vm.cancel
      }
    }, [_vm._v("\n         " + _vm._s(_vm.confirmCancelText || _vm.cancelText) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "btn ok",
      on: {
        "click": function click($event) {
          return _vm.$emit('ok');
        }
      }
    }, [_vm._v("\n         " + _vm._s(_vm.confirmOkText || _vm.okText) + "\n        ")])])];
  })], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };